import { Store } from '../../store/store.model';
export const selectActiveOutageAlerts = (store: Store) => store?.outageAlerts ?? null;
